import "./Charts.css";
import { useState, useEffect } from "react";

const ComparativeTable = ({
  previousData,
  previousYear,
  currentData,
  currentYear,
  title,
  selectedKey,
  frozenKey,
  onBarClick }) => {

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [frozenYear, setFrozenYear] = useState(null);
  const [frozenData, setFrozenData] = useState({});
  const [isFrozen, setIsFrozen] = useState(false);

  const dataToRenderPrev = frozenYear === previousYear ? frozenData.previous || previousData : previousData;
  const dataToRenderCurr = frozenYear === currentYear ? frozenData.current || currentData : currentData;

  useEffect(() => {
    if (frozenKey !== title) {
      setFrozenYear(null);
      setFrozenData({});
      setIsFrozen(false);
    }
  }, [frozenKey, title]);


  if (!dataToRenderPrev?.length || !dataToRenderCurr?.length) {
    return (
      <div className="chart-card">
        <h3>{title}</h3>
        <div className="chart-body empty">
          <p style={{ textAlign: "center", color: "#888", margin: "20px 0" }}>
            Sin datos disponibles
          </p>
        </div>
      </div>
    );
  }

  const COLUMN_ORDER = ['dia', 'Madrugada', 'Mañana', 'Tarde', 'Noche'];
  const DAY_ORDER = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];

  const getNonZeroColumns = (data) => {
    return COLUMN_ORDER.filter(col =>
      data.some(row => col !== 'dia' && parseFloat(row[col]) !== 0 || col === 'dia')
    );
  };

  const getFilteredAndSortedRows = (data, columnsToShow) => {
    return data
      .filter(row =>
        columnsToShow
          .filter(col => col !== 'dia')
          .some(col => parseFloat(row[col]) !== 0)
      )
      .sort((a, b) =>
        DAY_ORDER.indexOf(a['dia']) - DAY_ORDER.indexOf(b['dia'])
      );
  };

  const renderTable = (data, color, year) => {
    const columnsToShow = getNonZeroColumns(data);
    const rowsToRender = getFilteredAndSortedRows(data, columnsToShow);

    const onlyDayColumn = columnsToShow.length === 1 && columnsToShow[0] === 'dia';
    if (onlyDayColumn || rowsToRender.length === 0) {
      return (
        <div className="comparative-table" style={{ backgroundColor: color }}>
          <h3>Datos {year}</h3>
          <div className="chart-body empty">
            <p style={{ textAlign: "center", color: "#888", margin: "20px 0" }}>
              Sin datos disponibles
            </p>
          </div>
        </div>
      );
    }

    return (
      <div className="comparative-table" style={{ backgroundColor: color }}>
        <h3>Datos {year}</h3>
        <table>
          <thead>
            <tr>
              {columnsToShow.map((col) => (
                <th key={col}>{col === 'dia' ? 'Día' : col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rowsToRender.map((row, rowIndex) => {
              const rowName = row['dia'];

              return (
                <tr key={rowIndex}>
                  {columnsToShow.map((col) => {
                    const value = row[col];
                    const key = `${rowName}-${col}-${year}`;
                    const isSelected = selectedKey === key;
                    const isDayColumn = col === 'dia';

                    return (
                      <td
                        key={col}
                        onClick={
                          isDayColumn ? undefined : () => handleCellClick(rowName, col, year)
                        }
                        style={{
                          cursor: isDayColumn ? 'default' : 'pointer',
                          fontWeight: isSelected ? 'bold' : 'normal',
                          backgroundColor: isSelected ? '#ccc' : 'transparent'
                        }}
                      >
                        {value}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };



  const handleCellClick = (rowName, col, year) => {
    const key = `${rowName}-${col}-${year}`;
    const isSameSelection = selectedCategory === key;

    if (isSameSelection && frozenYear === year) {
      setFrozenYear(null);
      setFrozenData({ previous: null, current: null });
      setSelectedCategory(null);
      setIsFrozen(false);
      if (onBarClick) onBarClick(null);
      return;
    }
    if (!isFrozen) {
      setIsFrozen(true);
      setFrozenData({
        previous: [...dataToRenderPrev],
        current: [...dataToRenderCurr]
      });
    }
    setFrozenYear(year);
    setSelectedCategory(key);
    if (onBarClick) onBarClick({ category: key });
  };

  return (
    <div className="chart-card">
      <h3>{title}</h3>
      <div className="comparative-container">
        {renderTable(dataToRenderPrev, "#00BFFF", previousYear)}
        {renderTable(dataToRenderCurr, "#FFA500", currentYear)}
      </div>
    </div>
  );
};

export default ComparativeTable;
